import { render } from "./Table.vue?vue&type=template&id=cc9420f2&ts=true"
import script from "./Table.vue?vue&type=script&lang=ts"
export * from "./Table.vue?vue&type=script&lang=ts"

import "./Table.vue?vue&type=style&index=0&id=cc9420f2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__